// extracted by mini-css-extract-plugin
module.exports = {"groups":"groups-module--groups--Gc5v2","content":"groups-module--content--1OyRk"};